import { Injectable } from '@angular/core';
import { IID_RISORSE_CREATION } from '@common/interfaces/interfaceData';
import { AbstractInterfaceDataQuery } from '../interfaceDataModel';
import { IIDRisorseCreationStore } from './iidRisorseCreation.store';
import { InterfaceDataQuery } from '../interfaceDataRegistry';
import { InterfaceName } from '@common/interfaces/issueTypeInterface';

@Injectable({
  providedIn: 'root'
})
@InterfaceDataQuery(InterfaceName.RISORSE_CREATION)
export class IIDRisorseCreationQuery extends AbstractInterfaceDataQuery<IID_RISORSE_CREATION> {

  constructor(protected store: IIDRisorseCreationStore) {
    super(store);
  }
}
